export const chartStrokePalette = [
    '#0D9488', // teal-600
    '#3B82F6', // blue-500
    '#EF4444', // red-500
    '#22C55E', // green-500
    '#A855F7', // purple-500
    '#FF6900', // orange-500
    '#EC4899', // pink-500
    '#6366F1', // indigo-500
    '#F59E0B', // amber-500
    '#0F766E', // teal-700
] as const;

export const chartFillPalette = [
    '#0D9488',
    '#3B82F6',
    '#EF4444',
    '#22C55E',
    '#A855F7',
    '#FF6900',
    '#EC4899',
    '#6366F1',
    '#F59E0B',
    '#0F766E',
] as const;

export const ml360SeriesColors = {
    self: { stroke: chartStrokePalette[0], fill: chartFillPalette[0], fillOpacity: 0.3 },
    buddy: { stroke: chartStrokePalette[1], fill: chartFillPalette[1], fillOpacity: 0.22 },
    trainer: { stroke: chartStrokePalette[2], fill: chartFillPalette[2], fillOpacity: 0.18 },
};
